export default {
  validation: {
    required: 'The {{field}} field is required',
    emailInvalid: 'Please enter a valid e-mail address',
    emailUsed:
      'This e-mail address is already being used. Try to sign in instead.',
    minLength:
      'This {{field}} is too short. Please enter at least {{length}} characters.',
    maxLength:
      'This {{field}} is too long. Please enter at most {{length}} characters.',
    fieldInvalid: 'This {{field}} cannot be used, please try another.',
    matchingPasswords: "Passwords don't match",
  },
  error: {
    unknown: 'Oops! Something went wrong. Please try again.',
  },
};
